import PeopleStore from "./PeopleStore";
import StationAdoptStore from "../stationadopt/StationAdoptStore";
import * as lscache from 'lscache';

const hours = 1;
class CheckInStore {

    storageKey = 'CheckInStore2_' + process.env.REACT_APP_ENV ;

    async isCheckedIn() {
        var info = await this.read();
        console.log('isCheckedIn: ', info);
        return info.data.personId;
    }

    /**
     * Given a person id, returns a filled out structure with the same information
     * as if the person had checked in including local station information,
     * first name, last name, etc.
     *
     * @param personId
     * @returns {Promise<{firstName, lastName, shift, checkInTime, action: string, personId: *, stationId: string}>}
     */
    async loadDataFromPersonId(personId) {

        var adoptedStation = await new StationAdoptStore().read();
        var stationId = adoptedStation.data.stationId;
        if (!stationId)
            throw('Station has not been assigned');
        if (!personId)
            throw('no person id');
        var peopleData = await new PeopleStore().findById(personId);


        var data = {
            stationId: stationId,
            personId: personId,
            firstName: peopleData.data.firstName,
            lastName: peopleData.data.lastName,
            fullName: peopleData.data.firstName + ' ' + peopleData.data.lastName,
            shift: peopleData.data.shift,
            checkInTime: new Date(),
            action: 'checkout'
        }

        return data;
    }

    /**
     * Given a personId, checks in with a fully filled out
     * data structure, see loadDataFromPersonId
     *
     * @param personData
     * @returns {Promise<unknown>}
     */
    async save(personId) {

        var data = this.loadDataFromPersonId(personId);

        if (data.action == 'checkout') {
            this.checkOut();
            return {data: data};
        }

        var minutes = 60;
        var adoptedStation = await new StationAdoptStore().read();
        var stationId = adoptedStation.data.stationId;
        if (!stationId)
            throw('Station has not been assigned');
        if (!personId)
            throw('no person id');
        var peopleData = await new PeopleStore().findById(personId);


        var data = {
            stationId: stationId,
            personId: personId,
            firstName: peopleData.data.firstName,
            lastName: peopleData.data.lastName,
            shift: peopleData.data.shift,
            checkInTime: new Date(),
            action: 'checkout'
        }

        console.log('Checking in: ', data);
        var json = JSON.stringify(data);
        lscache.set(this.storageKey, json, hours * 60);

        var result = {data: data};
        return new Promise((resolve, reject) => {
            resolve(result)
        });

    }

    /**
     * Checks out the local operator, removing them from
     * local storage
     *
     * @returns {Promise<unknown>}
     */
    async checkOut() {
        var json = lscache.remove(this.storageKey);
        var data = {data: {action: 'checkout'}}
        return new Promise((resolve, reject) => {
            resolve(data)
        });
    }


    /**
     * Loads local check in data
     *
     * @returns {Promise<unknown>}
     */
    async read() {
        console.log('Loading check in info');
        var json = lscache.get(this.storageKey);
        console.log('Loaded', {json});
        json = json ? JSON.parse(json) : {};
        json.id = 'undefined';
        var data = {data: json}
        console.log('Loaded check in info', json);
        return new Promise((resolve, reject) => {
            resolve(data)
        });
    }


}

export default CheckInStore;
